import { API, axios } from '@Root/API'

export const getDynamic = () => {
	return Promise.all([axios.get(`student-types`), API.admin.institution.getRelated()])
}
